<template>
  <p class="payment-term-count">
    <span>
      {{ $t('paymentTerms.payment_number', { number: index + 1 }) }}
    </span>

    <span>
      {{ term.amount_decorated }} {{ this.currency }}
    </span>
  </p>
</template>

<script>
export default {
  props: {
    currency: String,

    index: {
      default: null,
      required: true,
      type: Number
    },

    term: {}
  }
}
</script>
